import propTypes from "prop-types";

export default {
  display: propTypes.bool
};
